import { Star, ArrowUpRight } from "lucide-react";
import { GOOGLE_PROFILE_URL, openGoogleProfile } from "@/lib/google";

const GOOGLE_URL = GOOGLE_PROFILE_URL;

// Replace these placeholder quotes with real customer reviews when available.
const REVIEWS = [
  {
    name: "Verified Google customer",
    quote:
      "Brought my car to AB Car details — absolutely spotless inside and out. You can tell every inch was given proper care. Highly recommend.",
    initials: "G",
  },
  {
    name: "Verified Google customer",
    quote:
      "Showed up on time, friendly, and the finish was unreal. Interior looked brand new again. Will be a repeat customer for sure.",
    initials: "G",
  },
  {
    name: "Verified Google customer",
    quote:
      "Honestly the best detail I've had in Christchurch. Affordable, mobile, and they don't cut corners. 5 stars all day.",
    initials: "G",
  },
];

export default function Reviews() {
  return (
    <section id="reviews" data-testid="reviews-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div>
            <div className="text-xs uppercase tracking-[0.25em] text-gold">
              06 — Reviews
            </div>
            <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1.02]">
              Trusted by Christchurch drivers.
            </h2>
          </div>

          <a
            href={GOOGLE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={openGoogleProfile}
            data-testid="reviews-google-badge"
            className="inline-flex items-center gap-4 bg-[#0a0a0a] border border-white/15 hover:border-white/40 rounded-xl p-5 transition-colors group cursor-pointer"
          >
            <div>
              <div className="text-[11px] uppercase tracking-[0.2em] text-neutral-500">Google rating</div>
              <div className="flex items-center gap-2 mt-1">
                <span className="font-display text-3xl font-black leading-none">5.0</span>
                <div className="flex">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" strokeWidth={1.5} />
                  ))}
                </div>
              </div>
            </div>
            <div className="border-l border-white/10 pl-4">
              <div className="text-xs text-neutral-300 leading-tight">View on<br />Google Maps</div>
            </div>
            <ArrowUpRight className="w-4 h-4 text-neutral-400 group-hover:text-white transition-colors" strokeWidth={1.6} />
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {REVIEWS.map((r, i) => (
            <figure
              key={i}
              data-testid={`review-card-${i}`}
              className="bg-[#0a0a0a] border border-white/10 rounded-xl p-7 hover:border-white/30 transition-colors flex flex-col"
            >
              <div className="flex items-center gap-1 mb-5">
                {Array.from({ length: 5 }).map((_, j) => (
                  <Star key={j} className="w-3.5 h-3.5 fill-yellow-400 text-yellow-400" strokeWidth={1.5} />
                ))}
              </div>
              <blockquote className="text-neutral-200 leading-relaxed text-[15px] flex-1">
                "{r.quote}"
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-white/10 flex items-center gap-3">
                <span className="inline-flex w-9 h-9 rounded-full bg-white/10 items-center justify-center font-display font-bold text-sm">
                  {r.initials}
                </span>
                <div>
                  <div className="text-sm font-display">{r.name}</div>
                  <div className="text-[11px] uppercase tracking-[0.18em] text-neutral-500">via Google</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
          <p className="text-sm text-neutral-400 max-w-md">
            Loved the result? Help other Christchurch drivers find us — leave a quick review.
          </p>
          <a
            href={GOOGLE_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={openGoogleProfile}
            data-testid="reviews-cta-btn"
            className="inline-flex items-center gap-2 bg-white text-black hover:bg-neutral-200 px-6 py-3 text-xs uppercase tracking-[0.2em] font-bold transition-colors cursor-pointer"
          >
            Leave a Google review <ArrowUpRight className="w-4 h-4" strokeWidth={1.8} />
          </a>
        </div>
      </div>
    </section>
  );
}
